import { Typography } from "@mui/material";

import { Flex } from "~/components/Flex";

interface SecurityPipelineGithubPageTabHeadingProps {
  title: string;
  description: string;
}

export const SecurityPipelineGithubPageTabHeading = ({
  title,
  description,
}: SecurityPipelineGithubPageTabHeadingProps) => {
  return (
    <Flex flexDirection="column">
      <Typography sx={{ fontSize: "20px", fontWeight: 700 }}>
        {title}
      </Typography>
      <Typography color="text.secondary">{description}</Typography>
    </Flex>
  );
};
